import React from 'react';

import type { TRatesTableV2 } from './models';

export const RatesTable = ({
    RatesTableBody,
    RatesTableHeader,
    columnNames,
    fontConfig,
    isMobile,
    loading,
    rowsCount,
    shortDesktop,
    shortStyles,
    shortVersion,
    styles,
    tableData,
}: TRatesTableV2) => {
    const tableStyles = shortVersion && shortStyles ? shortStyles : styles;

    return tableData.length === 0 && !loading ? null : (
        <table
            cellPadding="0"
            cellSpacing="0"
            className={isMobile ? styles.tableLayoutMobile : styles.tableLayout}
        >
            <RatesTableHeader
                columnNames={columnNames}
                isMobile={isMobile}
                shortDesktop={shortDesktop}
                styles={tableStyles}
            />
            <RatesTableBody
                fontConfig={fontConfig}
                isMobile={isMobile}
                loading={loading}
                rates={tableData}
                rowsCount={rowsCount}
                styles={tableStyles}
            />
        </table>
    );
};
